import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "d-flex justify-end sticky to-header"
  }, [_vm.hasRight('DEVICE_WRITE') ? _c(VBtn, _vm._b({
    attrs: {
      "to": {
        name: 'NewTurnstile'
      },
      "title": "Hozzáadás"
    }
  }, 'v-btn', _vm.$config.buttonAttrs.floating, false), [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("mdi-plus")])], 1) : _vm._e()], 1), _c('h1', {
    staticClass: "py-6"
  }, [_vm._v("Forgóvillák")]), _c(VExpansionPanels, {
    staticClass: "mb-4",
    attrs: {
      "mandatory": !!Object.values(_vm.search).find(function (e) {
        return e !== '';
      })
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('span', [_c(VIcon, {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-filter")]), _vm._v(" Szűrés ")], 1)]), _c(VExpansionPanelContent, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": 12,
      "sm": 4,
      "md": 3
    }
  }, [_c(VTextField, {
    attrs: {
      "label": "Megnevezés",
      "clearable": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.searchEventHandler
    },
    model: {
      value: _vm.search.name,
      callback: function ($$v) {
        _vm.$set(_vm.search, "name", $$v);
      },
      expression: "search.name"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": 12,
      "sm": 4,
      "md": 3
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "label": "Épület",
      "items": _vm.buildings,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "clearable": ""
    },
    on: {
      "change": _vm.buildingChangedEventHandler
    },
    model: {
      value: _vm.search.building_id,
      callback: function ($$v) {
        _vm.$set(_vm.search, "building_id", $$v);
      },
      expression: "search.building_id"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": 12,
      "sm": 4,
      "md": 3
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "label": "Épület szint",
      "items": _vm.buildingLevels,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "clearable": "",
      "placeholder": _vm.search.building_id ? 'Összes szint' : 'Épület kötelező',
      "readonly": !_vm.search.building_id
    },
    on: {
      "change": _vm.searchEventHandler
    },
    model: {
      value: _vm.search.building_level_id,
      callback: function ($$v) {
        _vm.$set(_vm.search, "building_level_id", $$v);
      },
      expression: "search.building_level_id"
    }
  })], 1)], 1)], 1)], 1)], 1), _c(VCard, [_c(VDataTable, {
    attrs: {
      "loading": _vm.loading,
      "headers": _vm.dataTable.headers,
      "items": _vm.dataTable.items,
      "server-items-length": _vm.dataTable.itemsLength,
      "options": _vm.dataTable.options,
      "footer-props": _vm.$config.dataTableFooterProps
    },
    on: {
      "update:options": function ($event) {
        return _vm.$set(_vm.dataTable, "options", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "item.k",
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(_vm._s(item.x_coord) + ", " + _vm._s(item.y_coord))];
      }
    }, {
      key: "item.actions",
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm.hasRight('DEVICE_WRITE') ? _c(VBtn, {
          staticClass: "rounded-sm",
          attrs: {
            "fab": "",
            "small": "",
            "dark": "",
            "text": "",
            "color": "secondary",
            "to": {
              name: 'TurnstileEditor',
              params: {
                id: item.element_id
              }
            },
            "title": "Módosítás"
          }
        }, [_c(VIcon, [_vm._v("mdi-pencil")])], 1) : _vm._e(), _vm.hasRight('DEVICE_WRITE') ? _c(VBtn, {
          staticClass: "rounded-sm",
          attrs: {
            "fab": "",
            "small": "",
            "color": "secondary",
            "dark": "",
            "text": "",
            "title": "Törlés"
          },
          on: {
            "click": function ($event) {
              return _vm.deleteTurnstile(item.element_id);
            }
          }
        }, [_c(VIcon, [_vm._v("mdi-delete")])], 1) : _vm._e()];
      }
    }], null, true)
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }